// Sprint 3 — Mejoras al Booking Wizard público

export type RememberedClient = {
  name: string;
  email: string;
  phone: string;
};

export function rememberedClientKey(slug: string) {
  return `booking_remembered_${slug}`;
}

export function loadRememberedClient(slug: string): RememberedClient | null {
  try {
    const raw = localStorage.getItem(rememberedClientKey(slug));
    if (!raw) return null;
    const j = JSON.parse(raw) as Partial<RememberedClient>;
    if (typeof j.name !== "string" || typeof j.email !== "string") return null;
    return { name: j.name, email: j.email, phone: typeof j.phone === "string" ? j.phone : "" };
  } catch {
    return null;
  }
}

export function saveRememberedClient(slug: string, data: RememberedClient) {
  localStorage.setItem(rememberedClientKey(slug), JSON.stringify(data));
}

export function clearRememberedClient(slug: string) {
  localStorage.removeItem(rememberedClientKey(slug));
}
